import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import { ParametersContext } from '../Parameters'
import ShareDetailsContext from './ShareDetailsContext'
import { formatPolicy } from '../../adapters/policy'

const getBrowserLanguage = () => (
  window.navigator.language && window.navigator.language.slice(0, 2)
)

const ShareDetailsProvider = ({ children }) => {
  const {
    clientSdkId,
    scenarioId,
    language,
    referrer
  } = useContext(ParametersContext)
  const [details, setDetails] = useState({});
  const [error, setError] = useState();

  const DEFAULT_APP_NAME = 'unknown'
  const VERIFIED_STATUS = 'VERIFIED'

  const getDetails = async () => {
    try {
      const {
        features,
        urls: { shareApiUrl },
        locale,
        device
      } = await Yoti.Share.getContext()

      const applicationsPath = 'applications/'
      const detailsUrl = `${shareApiUrl}${applicationsPath}${clientSdkId}?scenarioId=${scenarioId}`
      const { data } = await axios.get(detailsUrl)

      const {
        organisation, // organisation can be null
        application = {},
        scenario = {}
      } = data

      setDetails({
        application: {
          applicationName: application.name || DEFAULT_APP_NAME,
          applicationLogoUrl: application.logoUrl,
          applicationVerified: organisation && organisation.status === VERIFIED_STATUS || false,
          applicationReferringWebsite: referrer,
          clientSdkId
        },
        scenario: {
          scenarioId: scenario.scenarioId,
          policyAttributes: formatPolicy(scenario.policy)
        },
        // TODO: decoding/validation for language url param
        locale: language || locale || getBrowserLanguage() || 'en',
        device,
        features
      })
    } catch (e) {
      setError(e)
    }
  }

  useEffect(() => {
    getDetails()
  }, [])

  if (error) {
    // Error will be caught by the Error Boundary
    throw error
  }

  return (
    <ShareDetailsContext.Provider value={details}>
      {children}
    </ShareDetailsContext.Provider>
  )
}

ShareDetailsProvider.defaultProps = {
  children: null
}

ShareDetailsProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element
  ])
}

export default ShareDetailsProvider
